import React, { useEffect, useState } from "react";
import ReactApexChart from "react-apexcharts";
import {
  Autocomplete,
  TextField,
  Chip,
  Radio,
  Box,
  CircularProgress,
} from "@mui/material";
import { fShortenNumber } from "../../util/formatNumber";

function Chart2({ apiResponse, isLoading, type }) {
  const [filter1categories, setFilter1Categories] = useState([]);
  const [filter1, setFilter1] = useState({ id: "", name: "" });
  const [filter2categories, setFilter2Categories] = useState([]);
  const [filter2, setFilter2] = useState({ id: "", name: "" });
  const [filter3categories, setFilter3Categories] = useState([]);
  const [filter3, setFilter3] = useState({ id: "", name: "" });
  const [selectedDrillDown, setSelectedDrillDown] = useState("d");

  const handleDrillDownChange = (event) => {
    setSelectedDrillDown(event.target.value);
    setCategories(
      apiResponse,
      setFilter1Categories,
      setFilter1,
      setFilter2Categories,
      setFilter2,
      setFilter3Categories,
      setFilter3,
      event.target.value
    );
  };

  const yAxisLabels = new Set();

  const series = plotSeries(
    apiResponse,
    filter1,
    filter2,
    filter3,
    selectedDrillDown,
    yAxisLabels
  );

  useEffect(() => {
    setCategories(
      apiResponse,
      setFilter1Categories,
      setFilter1,
      setFilter2Categories,
      setFilter2,
      setFilter3Categories,
      setFilter3,
      selectedDrillDown
    );
  }, [apiResponse]);

  return (
    <>
      {isLoading ? (
        <CircularProgress sx={{ color: "green" }} />
      ) : (
        <div id="chart">
          <div className="mb-3">
            <Radio
              checked={selectedDrillDown === "d"}
              onChange={handleDrillDownChange}
              value="d"
              name="radio-buttons"
              inputProps={{ "aria-label": "D" }}
            />
            <span>Visual 1</span>
            <Radio
              checked={selectedDrillDown === "b"}
              onChange={handleDrillDownChange}
              value="b"
              name="radio-buttons"
              inputProps={{ "aria-label": "B" }}
            />
            <span>Visual 2</span>
            <Radio
              checked={selectedDrillDown === "a"}
              onChange={handleDrillDownChange}
              value="a"
              name="radio-buttons"
              inputProps={{ "aria-label": "A" }}
            />
            <span>Visual 3</span>
            <Radio
              checked={selectedDrillDown === "c"}
              onChange={handleDrillDownChange}
              value="c"
              name="radio-buttons"
              inputProps={{ "aria-label": "C" }}
            />
            <span>Visual 4</span>
          </div>
          <Box
            sx={{
              mb: 3,
              display: "flex",
              flexDirection: { md: "row", xs: "column", sm: "column" },
              justifyContent: "space-between",
            }}
          >
            <Autocomplete
              disableClearable={true}
              options={filter1categories}
              fullWidth
              value={filter1}
              defaultValue={filter1}
              onChange={(event, value) => setFilter1(value)}
              sx={{
                ml: { md: 0, sm: 0 },
                mr: { md: 3, sm: 0 },
                mt: { md: 0, sm: 2, xs: 2 },
              }}
              getOptionLabel={(option) => option.name}
              renderTags={(value, getTagProps) =>
                value.map((option, index) => (
                  <Chip
                    {...getTagProps({ index })}
                    key={option.name}
                    size="small"
                    label={option.name}
                  />
                ))
              }
              renderInput={(params) => (
                <TextField {...params} label="Filter 1" />
              )}
            />
            <Autocomplete
              disableClearable={true}
              options={filter2categories}
              fullWidth
              value={filter2}
              defaultValue={filter2}
              onChange={(event, value) => setFilter2(value)}
              sx={{
                ml: { md: 0, sm: 0 },
                mr: { md: 3, sm: 0 },
                mt: { md: 0, sm: 2, xs: 2 },
              }}
              getOptionLabel={(option) => option.name}
              renderTags={(value, getTagProps) =>
                value.map((option, index) => (
                  <Chip
                    {...getTagProps({ index })}
                    key={option.name}
                    size="small"
                    label={option.name}
                  />
                ))
              }
              renderInput={(params) => (
                <TextField {...params} label="Filter 2" />
              )}
            />

            {selectedDrillDown === "d" && (
              <Autocomplete
                disableClearable={true}
                options={filter3categories}
                fullWidth
                value={filter3}
                defaultValue={filter3}
                onChange={(event, value) => setFilter3(value)}
                sx={{
                  ml: { md: 0, sm: 0 },
                  mr: { md: 3, sm: 0 },
                  mt: { md: 0, sm: 2, xs: 2 },
                }}
                getOptionLabel={(option) => option.name}
                renderTags={(value, getTagProps) =>
                  value.map((option, index) => (
                    <Chip
                      {...getTagProps({ index })}
                      key={option.name}
                      size="small"
                      label={option.name}
                    />
                  ))
                }
                renderInput={(params) => (
                  <TextField {...params} label="Filter 3" />
                )}
              />
            )}
          </Box>
          <ReactApexChart
            options={options(type, apiResponse, yAxisLabels)}
            series={series}
            type={type}
            height={350}
          />
        </div>
      )}
    </>
  );
}
export default Chart2;

function options(type, apiResponse, yAxisLabels) {
  return {
    chart: {
      type: type,
      height: 350,
    },
    plotOptions: {
      bar: {
        horizontal: false,
        columnWidth: "55%",
        endingShape: "rounded",
      },
    },
    dataLabels: {
      enabled: false,
    },
    stroke: {
      show: true,
      width: 2,
      // colors: ["transparent"],
    },
    grid: {
      row: {
        colors: ["#f3f3f3", "transparent"],
        opacity: 0.5,
      },
    },
    xaxis: {
      categories: apiResponse.metadata.periods,
    },
    yaxis: {
      title: {
        text: [...yAxisLabels].toString().replace(/,/g, "___"),
      },
      labels: {
        formatter: function (val) {
          return fShortenNumber(val);
        },
      },
    },
    fill: {
      opacity: 1,
    },
    tooltip: {
      y: {
        formatter(val) {
          return `${fShortenNumber(val)}`;
        },
      },
    },
  };
}

function plotSeries(
  apiResponse,
  filter1,
  filter2,
  filter3,
  selectedDrillDown,
  yAxisLabels
) {
  if (selectedDrillDown === "a") {
    const data = seriesDataA(apiResponse, filter1, filter2, yAxisLabels);

    return [
      ...new Set(apiResponse.data.map((datum) => datum.constituency)),
    ].map((constituency) => ({
      name: constituency,
      data: data(constituency),
    }));
  } else if (selectedDrillDown === "b") {
    const data = seriesDataB(apiResponse, filter1, filter2, yAxisLabels);

    return [...new Set(apiResponse.data.map((datum) => datum.key))].map(
      (key) => ({
        name: key,
        data: data(key),
      })
    );
  } else if (selectedDrillDown === "c") {
    const data = seriesDataC(apiResponse, filter1, filter2, yAxisLabels);

    return [...new Set(apiResponse.data.map((datum) => datum.group))].map(
      (group) => ({
        name: group,
        data: data(group),
      })
    );
  } else if (selectedDrillDown === "d") {
    const data = seriesDataD(
      apiResponse,
      filter3,
      filter1,
      filter2,
      yAxisLabels
    );

    return [
      {
        name: filter3.id,
        data: data,
      },
    ];
  }
}

function seriesDataD(apiResponse, filter3, filter1, filter2, yAxisLabels) {
  return apiResponse.data
    .filter(
      (a) =>
        a.group === filter3.id &&
        a.constituency === filter1.id &&
        a.key === filter2.id
    )
    .map(function (b) {
      yAxisLabels.add(b.value_type);
      return b.value;
    });
}

function seriesDataC(apiResponse, filter1, filter2, yAxisLabels) {
  return (group) =>
    apiResponse.data
      .filter(
        (a) =>
          a.group === group &&
          a.constituency === filter1.id &&
          a.key === filter2.id
      )
      .map(function (b) {
        yAxisLabels.add(b.value_type);
        return b.value;
      });
}

function seriesDataB(apiResponse, filter1, filter2, yAxisLabels) {
  return (key) =>
    apiResponse.data
      .filter(
        (a) =>
          a.key === key &&
          a.constituency === filter1.id &&
          a.group === filter2.id
      )
      .map(function (b) {
        yAxisLabels.add(b.value_type);
        return b.value;
      });
}

function seriesDataA(apiResponse, filter1, filter2, yAxisLabels) {
  return (constituency) =>
    apiResponse.data
      .filter(
        (a) =>
          a.constituency === constituency &&
          a.key === filter1.id &&
          a.group === filter2.id
      )
      .map(function (b) {
        yAxisLabels.add(b.value_type);
        return b.value;
      });
}

function setCategories(
  apiResponse,
  setFilter1Categories,
  setFilter1,
  setFilter2Categories,
  setFilter2,
  setFilter3Categories,
  setFilter3,
  selectedDrillDown
) {
  const categories1 = [
    ...new Set(
      apiResponse.data.map((datum) =>
        selectedDrillDown === "a" ? datum.key : datum.constituency
      )
    ),
  ];

  const categories1Final = categories1.map((category) => {
    return {
      id: category,
      name: category,
    };
  });

  setFilter1Categories(categories1Final);
  setFilter1(categories1Final[0]);

  const categories2 = [
    ...new Set(
      apiResponse.data.map((datum) =>
        selectedDrillDown === "c"
          ? datum.key
          : selectedDrillDown === "d"
          ? datum.key
          : datum.group
      )
    ),
  ];

  const categories2Final = categories2.map((category) => {
    return {
      id: category,
      name: category,
    };
  });
  setFilter2Categories(categories2Final);
  setFilter2(categories2Final[0]);

  if (selectedDrillDown === "d") {
    const categories3 = [
      ...new Set(apiResponse.data.map((datum) => datum.group)),
    ];

    const categories3Final = categories3.map((category) => {
      return {
        id: category,
        name: category,
      };
    });
    setFilter3Categories(categories3Final);
    setFilter3(categories3Final[0]);
  }
}
